<div class="dc main-content no-sidebar">
  <!-- Overlay que bloquea toda interacción mientras se descarga/importa -->
  <div *ngIf="descargando" class="dc-overlay-block" role="alert" aria-live="polite" [attr.aria-label]="faseDescargaImportar === 'importando' ? 'Importando certificado en token. Espere.' : 'Descargando certificado. Espere.'">
    <div class="dc-overlay-block-content">
      <span class="spinner dc-overlay-spinner" aria-hidden="true"></span>
      <p class="dc-overlay-block-text">
        <ng-container *ngIf="faseDescargaImportar === 'descargando'">Descargando certificado…</ng-container>
        <ng-container *ngIf="faseDescargaImportar === 'importando'">Certificado descargado. Importando en token…</ng-container>
      </p>
      <p class="dc-overlay-block-hint">No cierre esta ventana ni realice otras acciones.</p>
    </div>
  </div>
  <main class="workspace" id="main-content">
    <div class="workspace-header">
      <h1>Descargar certificado</h1>
      <p>Con tu número de solicitud y el complemento de firma podrás descargar tu certificado.</p>
    </div>

    <!-- Paso 0: Complemento no detectado -->
    <div *ngIf="showNotAvailableView" class="step-container lap-step-host">
      <app-local-agent-unavailable-panel
        [loading]="statusLoading"
        loadingMessage="Comprobando el complemento…"
        featureTag="Descarga de certificado"
        [downloadUrl]="agentDownloadUrl"
        (obtain)="openAgentDownload()"
        (refresh)="retryStatus()">
      </app-local-agent-unavailable-panel>
    </div>

    <!-- Flujo TokenSafe: pantallas 1-5 -->
    <ng-container *ngIf="showFlujo">
      <!-- Pantalla 1: Número de solicitud -->
      <div *ngIf="paso === 1" class="step-container dc-paso dc-paso-1" role="region" aria-labelledby="dc-paso1-title">
        <h2 id="dc-paso1-title" class="dc-paso-title">Vamos a empezar</h2>
        <p class="dc-paso-desc">Digita el número de solicitud que te dieron cuando pediste el certificado.</p>
        <div class="dc-form-row">
          <label for="dc-num-solicitud" class="dc-label">Número de solicitud</label>
          <input
            id="dc-num-solicitud"
            type="text"
            class="dc-input"
            [(ngModel)]="numSolicitud"
            [disabled]="validando"
            placeholder="Ej. 12345"
            aria-describedby="dc-err-p1"
            aria-invalid="!!errorPantalla" />
          <button type="button" class="btn btn-primary dc-btn-action" (click)="validarSolicitud()" [disabled]="validando" aria-label="Continuar">
            <span *ngIf="validando" class="spinner-inline" aria-hidden="true"></span>
            <i *ngIf="!validando" class="fas fa-arrow-right" aria-hidden="true"></i>
            Continuar
          </button>
        </div>
        <p *ngIf="errorPantalla" id="dc-err-p1" class="dc-error dc-error-below-field" role="alert">{{ errorPantalla }}</p>
      </div>

      <!-- Pantalla 2: Usuario escribe el correo → otp/solicitar lo confirma -->
      <div *ngIf="paso === 2" class="step-container dc-paso dc-paso-2" role="region" aria-labelledby="dc-paso2-title">
        <h2 id="dc-paso2-title" class="dc-paso-title">Queremos confirmar que eres tú</h2>
        <p class="dc-paso-desc">Ingresa el correo que usaste en esta solicitud. Te enviaremos un código para continuar.</p>
        <div class="dc-correo-masked">
          <span class="dc-label">Correo de la solicitud:</span>
          <strong>{{ correoEnmascarado }}</strong>
        </div>
        <div class="dc-form-row">
          <label for="dc-correo-digitado" class="dc-label">Tu correo electrónico</label>
          <input
            id="dc-correo-digitado"
            type="email"
            class="dc-input"
            [(ngModel)]="correoDigitado"
            [disabled]="enviandoOtp"
            placeholder="ejemplo@correo.com"
            aria-describedby="dc-err-p2"
            aria-invalid="!!errorPantalla" />
        </div>
        <p *ngIf="errorPantalla" id="dc-err-p2" class="dc-error dc-error-below-field" role="alert">{{ errorPantalla }}</p>
        <div class="dc-actions-row">
          <button type="button" class="btn btn-primary" (click)="enviarOtp()" [disabled]="enviandoOtp" aria-label="Enviar código al correo">
            <span *ngIf="enviandoOtp" class="spinner-inline" aria-hidden="true"></span>
            <i *ngIf="!enviandoOtp" class="fas fa-paper-plane" aria-hidden="true"></i>
            Enviar código
          </button>
          <button type="button" class="btn btn-secondary" (click)="reiniciarFlujo()" [disabled]="procesoEnCurso" aria-label="Empezar de nuevo"><i class="fas fa-rotate-left" aria-hidden="true"></i> Empezar de nuevo</button>
        </div>
      </div>

      <!-- Pantalla 3: Código OTP (mín. 5 dígitos) + cuenta regresiva y reloj -->
      <div *ngIf="paso === 3" class="step-container dc-paso dc-paso-3" role="region" aria-labelledby="dc-paso3-title">
        <h2 id="dc-paso3-title" class="dc-paso-title">Ingresa el código que te enviamos</h2>
        <p *ngIf="mensajeExito" class="dc-success dc-success-inline" role="status">{{ mensajeExito }}</p>
        <div class="dc-otp-message-block">
          <p class="dc-otp-message-text">Te enviamos un código a tu correo.</p>
          <p class="dc-otp-expires-text" *ngIf="!otpExpired">Expira en <strong class="dc-otp-expires-value">{{ countdownFriendlyMessage }}</strong></p>
        </div>
        <div class="dc-clock-wrap" [class.expired]="otpExpired" [class.warning]="countdownState === 'warning'" [class.critical]="countdownState === 'critical'">
          <div class="dc-clock-ring" role="progressbar" [attr.aria-valuenow]="remainingSeconds" aria-valuemin="0" [attr.aria-valuemax]="otpExpiresInSeconds" [attr.aria-label]="'Tiempo restante: ' + countdownLabel">
            <svg class="dc-clock-svg" viewBox="0 0 80 80" aria-hidden="true">
              <circle class="dc-clock-track" cx="40" cy="40" r="36" fill="none" stroke-width="6"/>
              <circle class="dc-clock-fill" cx="40" cy="40" r="36" fill="none" stroke-width="6" [attr.stroke-dasharray]="ringCircumference" [attr.stroke-dashoffset]="ringDashOffset" stroke-linecap="round"/>
            </svg>
            <span class="dc-clock-value" aria-live="polite">{{ countdownLabel }}</span>
          </div>
        </div>
        <p class="dc-expired-msg" *ngIf="otpExpired">El código expiró. Pulsa <strong>Empezar de nuevo</strong> y solicita otro en el paso anterior.</p>
        <div class="dc-form-row dc-otp-form" *ngIf="!otpExpired">
          <label for="dc-codigo-otp" class="dc-label">Código (mín. {{ otpMinLength }} dígitos)</label>
          <input id="dc-codigo-otp" type="text" class="dc-input dc-input-otp" [ngModel]="codigoOtp" (input)="onOtpCodeInput($event)" [disabled]="validandoOtp" placeholder="00000" [attr.maxlength]="otpMaxLength" inputmode="numeric" pattern="[0-9]*" autocomplete="one-time-code" aria-describedby="dc-otp-hint" aria-invalid="!!errorPantalla" />
          <span id="dc-otp-hint" class="dc-hint">El que recibiste por correo</span>
          <button type="button" class="btn btn-primary dc-btn-action" (click)="validarOtp()" [disabled]="!canSubmitOtp" aria-label="Validar código OTP">
            <span *ngIf="validandoOtp" class="spinner-inline" aria-hidden="true"></span>
            <i *ngIf="!validandoOtp" class="fas fa-check" aria-hidden="true"></i>
            Validar
          </button>
        </div>
        <p *ngIf="errorPantalla" id="dc-err-p3" class="dc-error dc-error-below-field" role="alert">{{ errorPantalla }}</p>
        <div class="dc-actions-row">
          <span></span>
          <button type="button" class="btn btn-secondary" (click)="reiniciarFlujo()" [disabled]="procesoEnCurso" aria-label="Empezar de nuevo"><i class="fas fa-rotate-left" aria-hidden="true"></i> Empezar de nuevo</button>
        </div>
      </div>

      <!-- Pantalla 4: Definir PIN -->
      <div *ngIf="paso === 4" class="step-container dc-paso dc-paso-4" role="region" aria-labelledby="dc-paso4-title">
        <h2 id="dc-paso4-title" class="dc-paso-title">Casi listo</h2>
        <p class="dc-paso-desc">Elige un PIN de 4 dígitos para proteger tu certificado en el token.</p>
        <div class="dc-pin-row">
          <div class="dc-form-row dc-pin-field">
            <label for="dc-pin" class="dc-label">PIN (4 dígitos)</label>
            <div class="dc-input-wrap-pin">
              <input
                id="dc-pin"
                type="text"
                class="dc-input dc-input-pin"
                [class.dc-pin-masked]="!showPin1"
                [(ngModel)]="pinUsuario"
                [disabled]="preparando"
                placeholder="****"
                maxlength="4"
                inputmode="numeric"
                autocomplete="off"
                aria-describedby="dc-err-p4 dc-pin-mismatch" />
              <button type="button" class="dc-pin-toggle" (mousedown)="showPin1 = true" (mouseup)="showPin1 = false" (mouseleave)="showPin1 = false" tabindex="-1" aria-label="Mostrar PIN mientras mantiene pulsado">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="dc-form-row dc-pin-field">
            <label for="dc-pin-confirm" class="dc-label">Confirmar PIN</label>
            <div class="dc-input-wrap-pin">
              <input
                id="dc-pin-confirm"
                type="text"
                class="dc-input dc-input-pin"
                [class.dc-pin-masked]="!showPin2"
                [(ngModel)]="pinConfirmacion"
                [disabled]="preparando"
                placeholder="****"
                maxlength="4"
                inputmode="numeric"
                autocomplete="off"
                aria-describedby="dc-err-p4 dc-pin-mismatch" />
              <button type="button" class="dc-pin-toggle" (mousedown)="showPin2 = true" (mouseup)="showPin2 = false" (mouseleave)="showPin2 = false" tabindex="-1" aria-label="Mostrar PIN mientras mantiene pulsado">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <p *ngIf="pinMismatch" id="dc-pin-mismatch" class="dc-error dc-error-below-field" role="alert">Los PIN no coinciden.</p>
        <p *ngIf="errorPantalla" id="dc-err-p4" class="dc-error dc-error-below-field" role="alert">{{ errorPantalla }}</p>
        <div class="dc-actions-row">
          <button type="button" class="btn btn-primary" (click)="prepararSesion()" [disabled]="preparando || !canSubmitPin" aria-label="Continuar">
            <span *ngIf="preparando" class="spinner-inline" aria-hidden="true"></span>
            <i *ngIf="!preparando" class="fas fa-arrow-right" aria-hidden="true"></i>
            Continuar
          </button>
          <button type="button" class="btn btn-secondary" (click)="reiniciarFlujo()" [disabled]="procesoEnCurso" aria-label="Empezar de nuevo"><i class="fas fa-rotate-left" aria-hidden="true"></i> Empezar de nuevo</button>
        </div>
      </div>

      <!-- Pantalla 5: Descargar e importar en token (gasta la solicitud) -->
      <div *ngIf="paso === 5" class="step-container dc-paso dc-paso-5" role="region" aria-labelledby="dc-paso5-title">
        <h2 id="dc-paso5-title" class="dc-paso-title">Último paso</h2>

        <!-- Cargando estado del token -->
        <div *ngIf="tokenPaso5Loading" class="dc-progress">
          <span class="spinner" aria-hidden="true"></span>
          <p>Comprobando token…</p>
        </div>

        <!-- Varios tokens: mostrar todos y pedir dejar solo uno -->
        <div *ngIf="!tokenPaso5Loading && tokensPaso5.length > 1" class="dc-token-multi" role="alert">
          <p class="dc-token-multi-aviso">Solo puede haber un token conectado. Desconecte los demás para continuar.</p>
          <div class="dc-token-list">
            <div *ngFor="let t of tokensPaso5" class="dc-token-box dc-token-box-multi" [class.dc-token-box-multi-ok]="!t.isUserPinLocked" [class.dc-token-box-multi-locked]="t.isUserPinLocked" [attr.aria-label]="'Token: ' + t.label + (t.isUserPinLocked ? ', PIN bloqueado' : ', PIN OK')">
              <div class="dc-token-icon" [class.dc-token-icon-no]="t.isUserPinLocked" aria-hidden="true">
                <i class="fas" [ngClass]="t.isUserPinLocked ? 'fa-lock' : 'fa-key'" aria-hidden="true"></i>
              </div>
              <div class="dc-token-info">
                <div class="dc-token-nombre">{{ t.label }}</div>
                <div class="dc-token-meta">{{ tokenMeta(t) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Un solo token (Opción C): más datos y solo continuar si PIN OK -->
        <div *ngIf="!tokenPaso5Loading && tokenPaso5" class="dc-token-box" [class.dc-token-box-pin-locked]="tokenPaso5.isUserPinLocked" [attr.aria-label]="'Token detectado: ' + tokenPaso5.label">
          <div class="dc-token-icon" [class.dc-token-icon-no]="tokenPaso5.isUserPinLocked" aria-hidden="true">
            <i class="fas" [ngClass]="tokenPaso5.isUserPinLocked ? 'fa-lock' : 'fa-key'" aria-hidden="true"></i>
          </div>
          <div class="dc-token-info">
            <div class="dc-token-nombre">{{ tokenPaso5.label }}</div>
            <div class="dc-token-meta">{{ tokenMeta(tokenPaso5) }}</div>
          </div>
        </div>

        <!-- Sin token (Opción B) -->
        <div *ngIf="!tokenPaso5Loading && tokensPaso5.length === 0 && !descargando && !importacionOk" class="dc-token-box dc-token-box-no" role="alert">
          <div class="dc-token-icon dc-token-icon-no" aria-hidden="true">
            <i class="fas fa-exclamation" aria-hidden="true"></i>
          </div>
          <div class="dc-token-info">
            <div class="dc-token-nombre">No hay token detectado</div>
            <div class="dc-token-meta">Conecta el token USB para continuar</div>
          </div>
        </div>
        <div *ngIf="!tokenPaso5Loading && !descargando && !importacionOk" class="dc-actions-row" style="margin-top: 0.75rem;">
          <button type="button" class="btn btn-secondary" (click)="loadTokenStatusPaso5()" [disabled]="procesoEnCurso" aria-label="Volver a detectar tokens">
            <i class="fas fa-rotate" aria-hidden="true"></i> Actualizar token
          </button>
        </div>

        <p *ngIf="errorPantalla" class="dc-error dc-error-below-field" role="alert">{{ errorPantalla }}</p>
        <div *ngIf="descargando" class="dc-progress" [attr.aria-live]="'polite'" [attr.aria-label]="faseDescargaImportar === 'importando' ? 'Importando en token' : 'Descargando certificado'">
          <span class="spinner" aria-hidden="true"></span>
          <p>
            <ng-container *ngIf="faseDescargaImportar === 'descargando'">Descargando certificado…</ng-container>
            <ng-container *ngIf="faseDescargaImportar === 'importando'">Certificado descargado. Importando en token…</ng-container>
          </p>
        </div>
        <div *ngIf="importacionOk" class="dc-success dc-success-paso5" role="status">
          <p><strong>Listo.</strong> Tu certificado se descargó e importó en el token.</p>
          <p class="dc-success-paso5-hint">Puede validar que el certificado quedó en el token viendo su contenido.</p>
          <div class="dc-success-paso5-actions">
            <button type="button" class="btn btn-primary dc-btn-validar" (click)="validarImportacion()" [disabled]="validandoContenido" aria-label="Validar importación: ver contenido del token">
              <span *ngIf="validandoContenido" class="spinner-inline" aria-hidden="true"></span>
              <i *ngIf="!validandoContenido" class="fas fa-circle-check" aria-hidden="true"></i>
              {{ validandoContenido ? 'Comprobando…' : 'Validar importación' }}
            </button>
            <button type="button" class="btn btn-secondary dc-btn-inicio" (click)="reiniciarFlujo()" [disabled]="procesoEnCurso" aria-label="Ir al inicio">
              <i class="fas fa-home" aria-hidden="true"></i> Ir al inicio
            </button>
          </div>
        </div>

        <ng-container *ngIf="!descargando && !importacionOk">
          <div *ngIf="tokenPaso5PinOk" class="dc-acuerdo-block">
            <button
              type="button"
              class="dc-acuerdo-toggle"
              [class.dc-acuerdo-toggle-on]="acuerdoDescargar"
              [attr.aria-pressed]="acuerdoDescargar"
              [attr.aria-label]="acuerdoDescargar ? 'Confirmación activada' : 'Activar confirmación'"
              [disabled]="procesoEnCurso"
              (click)="acuerdoDescargar = !acuerdoDescargar"
              role="switch">
              <span class="dc-acuerdo-toggle-thumb"></span>
            </button>
            <span class="dc-acuerdo-text">Entiendo que al descargar e importar se usará esta solicitud y no podré volver a usarla para este certificado.</span>
          </div>
          <div class="dc-actions-row dc-actions-paso5">
            <button type="button" class="btn btn-secondary dc-btn-inicio" (click)="reiniciarFlujo()" [disabled]="procesoEnCurso" aria-label="Ir al inicio del flujo">
              <i class="fas fa-home" aria-hidden="true"></i> Ir al inicio
            </button>
            <button type="button" class="btn btn-primary" (click)="descargarEImportar()" [disabled]="!canDescargarPaso5" aria-label="Descargar e importar certificado en token">
              <i class="fas fa-download" aria-hidden="true"></i> Descargar e importar
            </button>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </main>
</div>
